import { SpeciesEnum } from "requests";

export const ROOTS: {
  rootsNames: string[];
  teethNumbers: { [key in SpeciesEnum]?: number[] };
}[] = [
  {
    rootsNames: ["distal"],
    teethNumbers: {
      [SpeciesEnum.Dog]: [
        101,
        102,
        103,
        104,
        105,
        201,
        202,
        203,
        204,
        205,
        301,
        302,
        303,
        304,
        305,
        311,
        401,
        402,
        403,
        404,
        405,
        411,
        501,
        502,
        503,
        504,
        601,
        602,
        603,
        604,
        701,
        702,
        703,
        704,
        801,
        802,
        803,
        804
      ],
      [SpeciesEnum.Cat]: [
        101,
        102,
        103,
        104,
        105,
        106,
        109,
        201,
        202,
        203,
        204,
        205,
        206,
        209,
        301,
        302,
        303,
        304,
        401,
        402,
        403,
        404,
        501,
        502,
        503,
        504,
        506,
        601,
        602,
        603,
        604,
        606,
        701,
        702,
        703,
        704,
        801,
        802,
        803,
        804
      ],
      [SpeciesEnum.Rabbit]: [
        101,
        102,
        106,
        109,
        110,
        111,
        201,
        202,
        206,
        209,
        210,
        211,
        301,
        310,
        311,
        401,
        410,
        411
      ]
    }
  },
  {
    rootsNames: ["distal", "mesial"],
    teethNumbers: {
      [SpeciesEnum.Dog]: [
        106,
        107,
        206,
        207,
        306,
        307,
        308,
        309,
        310,
        406,
        407,
        408,
        409,
        410,
        506,
        507,
        606,
        607,
        707,
        707,
        708,
        807,
        807,
        808
      ],
      [SpeciesEnum.Cat]: [
        107,
        207,
        307,
        308,
        309,
        407,
        408,
        409,
        507,
        607,
        707,
        708,
        807,
        808
      ],
      [SpeciesEnum.Rabbit]: [107, 207, 307, 308, 309, 407, 408, 409]
    }
  },
  {
    rootsNames: ["distal", "mesial", "palatal"],
    teethNumbers: {
      [SpeciesEnum.Dog]: [108, 109, 110, 208, 209, 210, 508, 608],
      [SpeciesEnum.Cat]: [108, 208, 508, 608],
      [SpeciesEnum.Rabbit]: [108, 208]
    }
  }
];
